import { render, staticRenderFns } from "./tsComplaint.vue?vue&type=template&id=7160eb10&scoped=true"
import script from "./tsComplaint.vue?vue&type=script&lang=js"
export * from "./tsComplaint.vue?vue&type=script&lang=js"
import style0 from "./tsComplaint.vue?vue&type=style&index=0&id=7160eb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160eb10",
  null
  
)

export default component.exports